import { getLDClient } from './ld-client-ref';

// Mapped to the `launchdarkly.session_replay_url` APM span tag by dutchie-api's
// DD_TRACE_HEADER_TAGS config (see argocd-manifests).
export const LD_SESSION_REPLAY_HEADER = 'X-LD-Session-Replay-URL';

// TODO(GA cleanup): when LD Session Replay graduates to GA, archive this flag
// and delete the `client.variation()` gate in `getLDSessionReplayUrl()`.
export const LD_SESSION_REPLAY_FLAG = 'growth.ld-session-replay.rollout';

// Injected by whichever app installs `@launchdarkly/session-replay`, so apps
// that don't ship session replay don't bundle the plugin.
type SessionReplayUrlProvider = () => string | undefined;

let urlProvider: SessionReplayUrlProvider | undefined;

export function registerSessionReplayUrlProvider(provider: SessionReplayUrlProvider): void {
  urlProvider = provider;
}

/** Test seam. */
export function resetSessionReplayUrlProviderForTests(): void {
  urlProvider = undefined;
}

/**
 * Returns the current Session Replay URL deep-linked to "now", or undefined if
 * no provider is registered, the SDK isn't recording, the flag is off, or
 * anything throws. Never throws, safe to call from Apollo links.
 */
export function getLDSessionReplayUrl(): string | undefined {
  try {
    if (!urlProvider) return undefined;
    const client = getLDClient();
    if (!client) return undefined;
    if (!client.variation(LD_SESSION_REPLAY_FLAG, false)) return undefined;
    return urlProvider();
  } catch {
    return undefined;
  }
}
